import axios from "axios";
import {
    APIGetClubsRequest,
    APIGetClubsResponse,
    APIGetDisciplinesResponse,
    APIGetActivitiesResponse,
    APIGetLiguesResponse,
    APIGetValidityRequest,
    APIGetValidityResponse,
    APIPostRequestMembershipRequest,
    APIPostRequestMembershipResponse,
    APIPostConfirmMembershipResponse
} from "./facade";

const API_URL = "https://api.ffvoile.fr";
const API_KEY = "oask_5e7aecb0caccefaa6123342ae37d786a3857495310e957300a38fa7e5cf7c8b5"

export const getValidity = async (params: APIGetValidityRequest):Promise<APIGetValidityResponse> => {
    // @ts-ignore
    const { data } = await axios.get(API_URL + "/LicenciesDirect/Eligiblite", {
      params: params,
      headers: { Authorization: `${API_KEY}` },
    }).catch((error) => {
        window.location.replace("/error/serverError")
        return;
    });
    return data
}

export const getActivities = async ():Promise<APIGetActivitiesResponse> => {
    // @ts-ignore
    const { data } = await axios.get(API_URL + "/Licencies/Activites", {
        headers: { Authorization: `${API_KEY}` },
    }).catch((error) => {
        window.location.replace("/error/serverError")
        return;
    });
    return { activities: data };
}

export const getDisciplines = async ():Promise<APIGetDisciplinesResponse> => {
    // @ts-ignore
    const { data } = await axios.get(API_URL + "/Licencies/Pratiques", {
        headers: { Authorization: `${API_KEY}` },
    }).catch((error) => {
        window.location.replace("/error/serverError")
        return;
    });
    return { disciplines: data };
}

export const getLigues = async ():Promise<APIGetLiguesResponse> => {
    // @ts-ignore
    const { data } = await axios.get(API_URL + '/Structures/0/Structures', {
        headers: { Authorization: `${API_KEY}` },
    }).catch((error) => {
        window.location.replace("/error/serverError")
        return;
    });
    return { ligues: data };
}

export const getClubs = async (params: APIGetClubsRequest):Promise<APIGetClubsResponse> => {
    // @ts-ignore
    const { data } = await axios.get(API_URL + `/Structures/Search/${params.txtSearch}`, {
        headers: { Authorization: `${API_KEY}` },
    }).catch((error) => {
        window.location.replace("/error/serverError")
        return;
    });
    return { clubs: data };
}
// @ts-ignore
export const requestMembership = async (params: APIPostRequestMembershipRequest): Promise<APIPostRequestMembershipResponse> => {
    // @ts-ignore
    const { data } = await axios.post(API_URL + `/LicenciesDirect/Create`, {
        ...params},
        {
        headers: { Authorization: `${API_KEY}` },

    }).catch((error) => {
        window.location.replace("/error/serverError")
        return;
    });
    return { ...data };
}

export const confirmMembership = async (params: { hash: string }): Promise<APIPostConfirmMembershipResponse> => {
    // @ts-ignore
    const { data } = await axios.post(
        API_URL + `/LicenciesDirect/${params.hash}`,
        {},
        { headers: { Authorization: `${API_KEY}` } },
    ).catch((error) => {
        window.location.replace("/error/serverError")
        return;
    });

    return {
        ...data,
        ASSIGNATION_DATE: data.ASSIGNATION_DATE && new Date(data.ASSIGNATION_DATE),
        AVIS_DATE: data.AVIS_DATE && new Date(data.AVIS_DATE),
        CREATE_DATE: data.CREATE_DATE && new Date(data.CREATE_DATE),
        ERROR_DATE: data.ERROR_DATE && new Date(data.ERROR_DATE),
        TRANSACTION_DATE: data.TRANSACTION_DATE && new Date(data.TRANSACTION_DATE),
    };
}

export const postParentAuthFile = async (params: {file: File, draftHash: string}): Promise<any> => {
    const formData = new FormData();
    formData.append("file", params.file)
    await axios.post(
        API_URL + `/LicenciesDirect/${params.draftHash}/AutParentale`,
        formData,
        { headers: { Authorization: `${API_KEY}`, 'Content-Type': 'multipart/form-data' } },
    ).catch((error) => {
        window.location.replace("/error/serverError")
        return;
    });
}